export default __webpack_public_path__ + "static/media/Chariot-PassengerApp-Logo.7fd1d854.png";